import type { CallNotificationItem, Incident } from '@/signalr';

export const CALL_NOTIFICATION_DISPLAY_DURATION_MS = 20 * 60 * 1000;

export function orderIncidentsByCreatedTimeDescending(incidents: readonly Incident[]): Incident[] {
  return [...incidents].sort((a, b) => Date.parse(b.createdTimeUtc) - Date.parse(a.createdTimeUtc));
}

export function orderCallsByStartTimeDescending(calls: readonly CallNotificationItem[]): CallNotificationItem[] {
  return [...calls].sort((a, b) => Date.parse(b.startTimeUtc) - Date.parse(a.startTimeUtc));
}
